import { seedConfigFromSample } from "../../../../Routes/RenderPdf/seedConfig";
import { sampleData } from "../../../../Routes/RenderPdf/sampleData";
export function fetchPdfDataStarted(state, payload) {
    return {
        isProcessing: true,
        error: null,
        isDataFetched: false
    };
}

export function fetchPdfDataSuccess(state, payload) {
    var stored = payload && payload.data && payload.data.data && payload.data.data.data && payload.data.data.data.response;
    if (stored && Array.isArray(stored)) {
        // Re-seed stored data so any newly-added editable keys get defaults
        // even if the saved blob predates them.
        return {
            reportType: payload.data.data.data.reportType,
            data: stored,
            trendData: stored,
            isProcessing: false,
            dirty: false,
            error: null,
            isDataFetched: true
        };
    }
    return {
        isProcessing: false,
        error: null,
    };
}

export function fetchPdfDataFailed(state, payload) {
    // Baseline is already in state — ignore the error silently, matching the
    // original context behavior.
    return {
        isProcessing: false,
        isDataFetched: false
    };
}
